module.exports = __webpack_public_path__ + "static/media/era_commons.60cd6698.svg";